var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"chevron-right",attrs:{"width":"6","height":"11","fill":"none","viewBox":"0 0 6 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 9.39355L5 5.39355L1 1.39355","stroke":"inherit","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }